/* SALIHA — Product Cards Premium Enhancer
   Aggiunge: wishlist (LocalStorage), quick view trigger, badge da tag,
   senza modificare la struttura native Horizon. */

(function () {
  'use strict';

  var WISHLIST_KEY = 'saliha_wishlist';
  var BADGE_TAG_PREFIX = 'badge:';

  // ── Wishlist storage ──────────────────────────────────────
  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function inWishlist(id) {
    var list = getWishlist();
    return list.indexOf(String(id)) !== -1;
  }
  function toggleWishlist(id) {
    id = String(id);
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
      saveWishlist(list);
      return true;
    } else {
      list.splice(idx, 1);
      saveWishlist(list);
      return false;
    }
  }

  // ── Toast ─────────────────────────────────────────────────
  var toastTimer = null;
  function showToast(msg, icon) {
    var existing = document.querySelector('.spc-toast');
    if (existing) existing.remove();

    var t = document.createElement('div');
    t.className = 'spc-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');

    if (icon === 'heart') {
      t.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7-4.5-9.5-9C1 8 3.5 4 7.5 4c2 0 3.5 1 4.5 2.5C13 5 14.5 4 16.5 4c4 0 6.5 4 5 8-2.5 4.5-9.5 9-9.5 9z"/></svg>';
    } else if (icon === 'check') {
      t.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    }

    var span = document.createElement('span');
    span.textContent = msg;
    t.appendChild(span);
    document.body.appendChild(t);

    requestAnimationFrame(function () {
      t.classList.add('is-visible');
    });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 350);
    }, 2400);
  }

  // ── Inject quick actions into a card ──────────────────────
  function enhanceCard(card) {
    if (!card || card.dataset.spcEnhanced) return;
    card.dataset.spcEnhanced = '1';

    var productId = card.dataset.productId;
    if (!productId) return;

    // Trova il link al prodotto e ricava handle
    var link = card.querySelector('a[href*="/products/"]');
    var handle = '';
    if (link && link.href) {
      var m = link.href.match(/\/products\/([^/?#]+)/);
      if (m) handle = m[1];
    }
    if (!handle) return;


  }

  // ── Find all cards and enhance ────────────────────────────
  function enhanceAllCards(root) {
    root = root || document;
    var cards = root.querySelectorAll('product-card[data-product-id]');
    cards.forEach(enhanceCard);
  }

  // ── Init on DOM ready ─────────────────────────────────────
  function init() {
    enhanceAllCards();

    // Observer for dynamic loaded cards (filters, infinite scroll, search)
    var mo = new MutationObserver(function (mutations) {
      var pending = false;
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) pending = true;
      });
      if (pending) {
        // Throttle via rAF
        if (!init._scheduled) {
          init._scheduled = true;
          requestAnimationFrame(function () {
            enhanceAllCards();
            init._scheduled = false;
          });
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API
  window.SalihaWishlist = {
    get: getWishlist,
    has: inWishlist,
    toggle: toggleWishlist,
    count: function () { return getWishlist().length; }
  };
  window.SalihaToast = showToast;
})();

// ==========================================================
// SALIHA — Quick View Modal
// ==========================================================
(function () {
  'use strict';

  var modal = null;
  var lastFocused = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'spc-qv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Anteprima prodotto');
    modal.innerHTML = ''
      + '<div class="spc-qv-panel" role="document">'
      + '  <button type="button" class="spc-qv-close" aria-label="Chiudi anteprima">'
      + '    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">'
      + '      <line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>'
      + '    </svg>'
      + '  </button>'
      + '  <div class="spc-qv-loader" data-qv-loader><div class="spc-qv-spinner"></div></div>'
      + '  <div class="spc-qv-media" data-qv-media></div>'
      + '  <div class="spc-qv-info" data-qv-info></div>'
      + '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    var closeBtn = modal.querySelector('.spc-qv-close');
    closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (modal.dataset.open !== undefined && e.key === 'Escape') close();
    });

    return modal;
  }

  function open(handle) {
    if (!handle) return;
    ensureModal();
    lastFocused = document.activeElement;
    modal.setAttribute('data-open', '');
    modal.querySelector('[data-qv-media]').innerHTML = '';
    modal.querySelector('[data-qv-info]').innerHTML = '';
    modal.querySelector('[data-qv-loader]').style.display = 'flex';
    document.body.style.overflow = 'hidden';

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(render)
      .catch(function () {
        modal.querySelector('[data-qv-info]').innerHTML = '<p style="text-align:center;padding:40px 0;color:#9A8A76;">Impossibile caricare il prodotto.</p>';
        modal.querySelector('[data-qv-loader]').style.display = 'none';
      });
  }

  function close() {
    if (!modal) return;
    modal.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function fmtMoney(cents) {
    var locale = (document.documentElement.lang || 'it-IT').replace('_', '-');
    var amount = cents / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' €';
    }
  }

  function render(product) {
    var media = modal.querySelector('[data-qv-media]');
    var info = modal.querySelector('[data-qv-info]');
    var loader = modal.querySelector('[data-qv-loader]');

    // Media
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image.replace(/\.([^.]+)$/, '_900x.$1');
      img.alt = product.title;
      img.loading = 'eager';
      img.decoding = 'async';
      media.appendChild(img);
    }

    // Info
    var t = document.createElement('h2');
    t.className = 'spc-qv-title';
    t.textContent = product.title;
    info.appendChild(t);

    var p = document.createElement('div');
    p.className = 'spc-qv-price';
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvail.compare_at_price && firstAvail.compare_at_price > firstAvail.price) {
      p.innerHTML = '<span style="color:#b8963e">' + fmtMoney(firstAvail.price) + '</span><span class="spc-qv-price-compare">' + fmtMoney(firstAvail.compare_at_price) + '</span>';
    } else {
      p.textContent = fmtMoney(firstAvail.price);
    }
    info.appendChild(p);

    if (product.description) {
      var d = document.createElement('div');
      d.className = 'spc-qv-desc';
      // Strip HTML, mostra solo primi 280 char
      var tmp = document.createElement('div');
      tmp.innerHTML = product.description;
      var txt = (tmp.textContent || tmp.innerText || '').trim();
      d.textContent = txt.length > 280 ? txt.slice(0, 280) + '…' : txt;
      if (txt) info.appendChild(d);
    }

    // Variants
    var selectedOptions = {};
    if (product.variants.length > 1 && product.options.length) {
      var variantsWrap = document.createElement('div');
      variantsWrap.className = 'spc-qv-variants';
      product.options.forEach(function (optName, idx) {
        if (typeof optName !== 'string') optName = (optName && optName.name) || 'Opzione ' + (idx + 1);
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (idx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        if (values.length === 0) return;

        var group = document.createElement('div');
        group.className = 'spc-qv-variant-group';
        var lbl = document.createElement('label');
        lbl.textContent = optName;
        group.appendChild(lbl);

        var opts = document.createElement('div');
        opts.className = 'spc-qv-variant-options';

        values.forEach(function (val, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = val;
          btn.dataset.option = optName;
          btn.dataset.value = val;
          if (i === 0) {
            btn.setAttribute('aria-pressed', 'true');
            selectedOptions[optName] = val;
          } else {
            btn.setAttribute('aria-pressed', 'false');
          }
          btn.addEventListener('click', function () {
            opts.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            selectedOptions[optName] = val;
            updatePriceForSelection();
          });
          opts.appendChild(btn);
        });

        group.appendChild(opts);
        variantsWrap.appendChild(group);
      });
      info.appendChild(variantsWrap);
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (optName, idx) {
          if (typeof optName !== 'string') optName = (optName && optName.name) || 'Opzione ' + (idx + 1);
          return !selectedOptions[optName] || v['option' + (idx + 1)] === selectedOptions[optName];
        });
      });
    }

    function updatePriceForSelection() {
      var v = findVariant() || firstAvail;
      if (!v) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        p.innerHTML = '<span style="color:#b8963e">' + fmtMoney(v.price) + '</span><span class="spc-qv-price-compare">' + fmtMoney(v.compare_at_price) + '</span>';
      } else {
        p.textContent = fmtMoney(v.price);
      }
      addBtn.disabled = !v.available;
      addBtn.querySelector('.spc-qv-add-text').textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
    }

    // Actions
    var actions = document.createElement('div');
    actions.className = 'spc-qv-actions';
    var addBtn = document.createElement('button');
    addBtn.className = 'spc-qv-add';
    addBtn.type = 'button';
    addBtn.innerHTML = '<span class="spc-qv-add-text">' + (firstAvail.available ? 'Aggiungi al carrello' : 'Esaurito') + '</span>';
    addBtn.disabled = !firstAvail.available;
    addBtn.addEventListener('click', function () {
      var v = findVariant() || firstAvail;
      if (!v || !v.available) return;
      addBtn.disabled = true;
      var origText = addBtn.querySelector('.spc-qv-add-text').textContent;
      addBtn.querySelector('.spc-qv-add-text').textContent = 'Aggiungo…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        addBtn.classList.add('is-success');
        addBtn.querySelector('.spc-qv-add-text').textContent = 'Aggiunto ✓';
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'saliha-qv',
                data: { source: 'saliha-qv', itemCount: cart.item_count }
              }
            }));
          })
          .catch(function () {});
        if (window.SalihaToast) window.SalihaToast('Aggiunto al carrello', 'check');
        setTimeout(function () {
          close();
          addBtn.classList.remove('is-success');
          addBtn.querySelector('.spc-qv-add-text').textContent = origText;
          addBtn.disabled = !v.available;
        }, 1400);
      })
      .catch(function () {
        addBtn.querySelector('.spc-qv-add-text').textContent = 'Errore. Riprova.';
        addBtn.disabled = false;
      });
    });
    actions.appendChild(addBtn);

    var link = document.createElement('a');
    link.className = 'spc-qv-link';
    link.href = '/products/' + product.handle;
    link.textContent = 'Vedi tutti i dettagli →';
    actions.appendChild(link);

    info.appendChild(actions);

    loader.style.display = 'none';
  }

  window.SalihaQuickView = { open: open, close: close };
})();

// ==========================================================
// SALIHA — Bridge: quick-add nativo (multi-variante) → SalihaQuickView
// Il dialog nativo Horizon fetcha [data-product-grid-content] che la
// PDP custom saliha-product-page non ha → resterebbe vuoto.
// I bottoni --add (mono-variante) restano nativi: add diretto funzionante.
// ==========================================================
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.quick-add__button--choose') : null;
    if (!btn) return;
    var card = btn.closest('product-card') || btn.closest('.product-card');
    var link = card ? card.querySelector('a[href*="/products/"]') : null;
    var m = link ? link.getAttribute('href').match(/\/products\/([^/?#]+)/) : null;
    if (!m) return; // fallback: lascia il comportamento nativo
    e.preventDefault();
    e.stopImmediatePropagation();
    if (window.SalihaQuickView) window.SalihaQuickView.open(decodeURIComponent(m[1]));
    killNativeDialogs();
  }, true);

  // Il dialog nativo apre in async (dopo il suo fetch): observer permanente che lo richiude.
  function killNativeDialogs() {
    document.querySelectorAll('dialog.quick-add-modal').forEach(function (d) {
      if (d.dataset.spcKilled) return;
      d.dataset.spcKilled = '1';
      if (d.hasAttribute('open')) { try { d.close(); } catch (_) {} }
      new MutationObserver(function () {
        if (d.hasAttribute('open')) { try { d.close(); } catch (_) {} }
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', killNativeDialogs);
  } else {
    killNativeDialogs();
  }
})();
